import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nb from 'src/assets/translations/nb.json';
import gb from 'src/assets/translations/gb.json';
import { LocalStorage } from './utils/localStorage';
import { USER_LANGUAGE_KEY } from './store/persistStoreMiddleware';
import { Language } from './store/users/users.reducer';

export const initializeI18n = () => {
  i18n.use(initReactI18next).init({
    lng: LocalStorage.getItem<string>(USER_LANGUAGE_KEY) ?? Language.Norwegian,
    resources: {
      nb: { translations: nb },
      gb: { translations: gb }
    },
    fallbackLng: 'nb',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      useSuspense: true
    }
  });
};
